(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-hulkapps-backup"]) return;
  try {
    
  window.addEventListener('load', () => {
    const quantity = document.querySelector('#quantity [name=quantity]');
    const plusIcon = document.querySelector('.fa-plus');
    const minusIcon = document.querySelector('.fa-minus');

    plusIcon.addEventListener('click', () => {
      quantity.value++;
    });
    minusIcon.addEventListener('click', () => {
      if (quantity.value >= 2) quantity.value--;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  (() => {
    async function changeLineItem(lineKey, quantity) {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({
          id: lineKey,
          quantity: quantity,
        }),
      });

      if (!res.ok) throw new Error('Cart change failed');
      return await res.json(); // cart object
    }

    function formatMoneyFromTheme(cents) {
      // Einfacher Fallback (CHF). Wenn du ein Theme money-format hast, kann man das noch sauberer machen.
      try {
        return (cents / 100).toLocaleString('de-CH', { style: 'currency', currency: 'CHF' });
      } catch {
        return `${(cents / 100).toFixed(2)}`;
      }
    }

    function bindCartQtyControls() {
      document.querySelectorAll('.cart-item[data-line-key]').forEach((row) => {
        const key = row.getAttribute('data-line-key');
        const input = row.querySelector('[data-qty-input]');
        const plus = row.querySelector('[data-plus]');
        const minus = row.querySelector('[data-minus]');
        const remove = row.querySelector('[data-remove]');

        if (!key || !input || !plus || !minus) return;

        let isBusy = false;

        const setBusy = (busy) => {
          isBusy = busy;
          row.classList.toggle('is-loading', busy);
          input.disabled = busy;
          plus.style.pointerEvents = busy ? 'none' : '';
          minus.style.pointerEvents = busy ? 'none' : '';
        };

        const update = async (nextQty) => {
          nextQty = Math.max(0, parseInt(nextQty, 10) || 0);

          setBusy(true);
          try {
            const cart = await changeLineItem(key, nextQty);

            // Wenn qty auf 0 gesetzt wurde, Zeile entfernen
            if (nextQty === 0) {
              row.remove();
            } else {
              input.value = nextQty;
            }

            // Optional: Cart total updaten (wenn vorhanden)
            const totalEl = document.querySelector('[data-cart-total]');
            if (totalEl) totalEl.textContent = formatMoneyFromTheme(cart.total_price);

            // Optional: Line totals updaten (wenn du sie ausgeben willst)
            // Da /cart/change.js kein HTML liefert, muesstest du anhand cart.items das passende Item finden:
            const lineItem = cart.items.find((i) => i.key === key);
            const lineTotalEl = row.querySelector('[data-line-total]');
            if (lineItem && lineTotalEl) {
              lineTotalEl.textContent = formatMoneyFromTheme(lineItem.final_line_price);
            }
          } catch (e) {
            // Fehlerfall: Quantity wieder auf alten Wert? (hier minimal)
            console.error(e);
          } finally {
            setBusy(false);
          }
        };

        plus.addEventListener('click', () => {
          if (isBusy) return;
          update((parseInt(input.value, 10) || 0) + 1);
        });

        minus.addEventListener('click', () => {
          if (isBusy) return;
          const current = parseInt(input.value, 10) || 0;
          if (current <= 1) return;
          update(current - 1);
        });

        input.addEventListener('change', () => {
          if (isBusy) return;
          update(input.value);
        });

        if (remove) {
          remove.addEventListener('click', (e) => {
            // Entfernen ohne Seitenreload
            e.preventDefault();
            if (isBusy) return;
            update(0);
          });
        }
      });
    }

    window.addEventListener('load', bindCartQtyControls);

    function initCartCheckout() {
  const form = document.querySelector('#cart');
  const agbCheckbox = document.querySelector('#agb-check');
  const checkoutTriggerSelector = 'button[name="checkout"], input[name="checkout"], a[href="/checkout"], a[href*="/checkout"]';
  const noteInput = document.querySelector('#Cart-note');
  const noteAttributeInput = document.querySelector('#Cart-note-attribute');
  const deliveryDateInput = document.querySelector('#Cart-delivery-date');

  if (!form) return;
  if (form.dataset.cartCustomFieldsInitialized === 'true') return;
  form.dataset.cartCustomFieldsInitialized = 'true';

  let isPreparingCheckout = false;
  let isReplayingCheckout = false;
  let autosaveTimeout;

  function syncCheckoutState() {
    if (!agbCheckbox) return;
    const checkoutTriggers = document.querySelectorAll(checkoutTriggerSelector);

    if (agbCheckbox.checked) {
      checkoutTriggers.forEach((checkoutTrigger) => {
        checkoutTrigger.classList.remove('is-disabled');
        checkoutTrigger.removeAttribute('aria-disabled');
      });
    } else {
      checkoutTriggers.forEach((checkoutTrigger) => {
        checkoutTrigger.classList.add('is-disabled');
        checkoutTrigger.setAttribute('aria-disabled', 'true');
      });
    }
  }

  function setCheckoutBusy(isBusy) {
    document.querySelectorAll(checkoutTriggerSelector).forEach((checkoutTrigger) => {
      if ('disabled' in checkoutTrigger) {
        checkoutTrigger.disabled = isBusy;
      }
      checkoutTrigger.setAttribute('aria-busy', isBusy ? 'true' : 'false');
    });
  }

  function syncNoteHiddenInput() {
    if (noteInput && noteAttributeInput) {
      noteAttributeInput.value = noteInput.value;
    }
  }

  function scheduleCartCustomFieldsSave() {
    clearTimeout(autosaveTimeout);
    autosaveTimeout = setTimeout(() => {
      saveCartCustomFields().catch((error) => {
        console.error(error);
      });
    }, 500);
  }

  async function saveCartCustomFields() {
    clearTimeout(autosaveTimeout);
    syncNoteHiddenInput();

    const noteValue = noteInput ? noteInput.value : '';
    const deliveryDateValue = deliveryDateInput ? deliveryDateInput.value : '';
    const formData = new FormData(form);
    formData.set('note', noteValue);
    formData.set('attributes[Bestellbemerkung]', noteValue);
    formData.set('attributes[Gewünschter Liefertermin]', deliveryDateValue);

    const body = new URLSearchParams();
    formData.forEach((value, key) => {
      if (typeof value === 'string') {
        body.append(key, value);
      }
    });

    const res = await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        Accept: 'application/json',
      },
      body: body.toString(),
    });

    if (!res.ok) throw new Error('Cart custom fields could not be saved');

    const cart = await res.json();
    const savedNoteAttribute = cart.attributes && cart.attributes['Bestellbemerkung'];
    const savedDate = cart.attributes && cart.attributes['Gewünschter Liefertermin'];

    if ((noteValue && cart.note !== noteValue && savedNoteAttribute !== noteValue) || (deliveryDateValue && savedDate !== deliveryDateValue)) {
      throw new Error('Cart custom fields were not persisted');
    }

    return cart;
  }

  function wait(ms) {
    return new Promise((resolve) => {
      window.setTimeout(resolve, ms);
    });
  }

  async function waitForHulkDiscountsReady(cart) {
    if (!window.hulkapps || typeof window.getCartInfo !== 'function') {
      return;
    }

    try {
      window.getCartInfo(0, cart);
    } catch (error) {
      console.error(error);
      return;
    }

    await wait(150);

    const startedAt = Date.now();
    while (Date.now() - startedAt < 1800) {
      const checkoutTrigger = findCheckoutTrigger();
      const isDisabled = checkoutTrigger && 'disabled' in checkoutTrigger && checkoutTrigger.disabled;
      const hasDiscountState = window.hulkapps && window.hulkapps.discounts;

      if (!isDisabled && hasDiscountState) return;

      await wait(100);
    }
  }

  function findCheckoutTrigger(event) {
    if (event && event.submitter && event.submitter.matches && event.submitter.matches(checkoutTriggerSelector)) {
      return event.submitter;
    }

    if (event && event.target && event.target.closest) {
      return event.target.closest(checkoutTriggerSelector);
    }

    return document.querySelector(checkoutTriggerSelector);
  }

  function allowPreparedCheckout() {
    return isReplayingCheckout || form.dataset.cartCustomFieldsReady === 'true';
  }

  function resetPreparedCheckoutState() {
    window.setTimeout(() => {
      isReplayingCheckout = false;
      isPreparingCheckout = false;
      delete form.dataset.cartCustomFieldsReady;
    }, 1500);
  }

  async function prepareCheckout(event, checkoutTrigger) {
    if (allowPreparedCheckout()) return;

    event.preventDefault();
    event.stopPropagation();

    if (agbCheckbox && !agbCheckbox.checked) {
      agbCheckbox.reportValidity();
      agbCheckbox.focus();
      return;
    }

    if (isPreparingCheckout) return;
    isPreparingCheckout = true;
    setCheckoutBusy(true);

    try {
      const cart = await saveCartCustomFields();
      await waitForHulkDiscountsReady(cart);
      form.dataset.cartCustomFieldsReady = 'true';
      isReplayingCheckout = true;
      setCheckoutBusy(false);

      const triggerToContinue = checkoutTrigger || findCheckoutTrigger();
      if (triggerToContinue && typeof triggerToContinue.click === 'function') {
        triggerToContinue.click();
      } else if (typeof form.submit === 'function') {
        form.submit();
      }

      resetPreparedCheckoutState();
    } catch (error) {
      console.error(error);
      isPreparingCheckout = false;
      isReplayingCheckout = false;
      delete form.dataset.cartCustomFieldsReady;
      setCheckoutBusy(false);
      alert('Bestellbemerkung und Liefertermin konnten nicht gespeichert werden. Bitte versuche es erneut.');
    }
  }

  if (noteInput) {
    noteInput.addEventListener('input', syncNoteHiddenInput);
    noteInput.addEventListener('input', scheduleCartCustomFieldsSave);
    noteInput.addEventListener('change', scheduleCartCustomFieldsSave);
    syncNoteHiddenInput();
  }

  if (deliveryDateInput) {
    deliveryDateInput.addEventListener('change', scheduleCartCustomFieldsSave);
  }

  if (agbCheckbox) {
    agbCheckbox.addEventListener('change', syncCheckoutState);
  }

  document.addEventListener('click', (event) => {
    const checkoutTrigger = findCheckoutTrigger(event);

    if (checkoutTrigger) {
      prepareCheckout(event, checkoutTrigger);
    }
  }, true);

  form.addEventListener('submit', (event) => {
    prepareCheckout(event, findCheckoutTrigger(event));
  }, true);

  syncCheckoutState();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCartCheckout);
} else {
  initCartCheckout();
}

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const wrapper = document.querySelector('[data-search-wrapper]');
    if (!wrapper) return;

    const toggle = wrapper.querySelector('[data-search-toggle]');
    const form = wrapper.querySelector('[data-search-form]');
    const input = wrapper.querySelector('[data-search-input]');

    if (!toggle || !form || !input) return;

    function openSearch() {
      wrapper.classList.add('search-open');
      toggle.setAttribute('aria-expanded', 'true');

      requestAnimationFrame(function () {
        input.focus();
        if (input.value.length) {
          input.setSelectionRange(input.value.length, input.value.length);
        }
      });
    }

    function closeSearch() {
      wrapper.classList.remove('search-open');
      toggle.setAttribute('aria-expanded', 'false');
      input.blur();
    }

    toggle.addEventListener('click', function (event) {
      event.stopPropagation();

      if (wrapper.classList.contains('search-open')) {
        closeSearch();
      } else {
        openSearch();
      }
    });

    form.addEventListener('click', function (event) {
      event.stopPropagation();
    });

    document.addEventListener('click', function (event) {
      if (!wrapper.contains(event.target)) {
        closeSearch();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeSearch();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  window.addEventListener('load', () => {
    var quantity = document.querySelector('.quantity [name="quantity"]');
    var plusIcon = document.querySelector('.fa-plus');
    var minusIcon = document.querySelector('.fa-minus');

    if (quantity && plusIcon && minusIcon) {
      plusIcon.addEventListener('click', function () {
        quantity.value = parseInt(quantity.value, 10) + 1;
      });

      minusIcon.addEventListener('click', function () {
        var current = parseInt(quantity.value, 10) || 1;
        if (current >= 2) {
          quantity.value = current - 1;
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
